import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import QUERY, {
	type ThemeSetterQuery,
} from '@jira/platform__project-theme-setter/src/__generated__/ThemeSetterQuery.graphql.ts';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { withGiraAggAnonSsrFix } from './withGiraAggAnonSsrFix.tsx';

// We will revert it back to use without withGiraAggAnonSsrFix once the underlying
// auth issues have been fixed in https://hello.jira.atlassian.cloud/browse/DEE-7165
export const projectThemeResource: RouteResource<
	PreloadedQuery<ThemeSetterQuery, Record<string, unknown>>
> = withGiraAggAnonSsrFix(
	createRelayResource<ThemeSetterQuery>({
		type: 'JIRA_PROJECT_THEME',
		getQuery: ({ match, query }, { tenantContext }) => {
			const { projectKey, projectId } = getProjectKeyId(match, query);
			const { cloudId } = tenantContext;

			return {
				parameters: QUERY,
				variables: {
					cloudId,
					projectIdOrKey: projectKey ?? projectId ?? '',
					withPersistDominantColor: fg('th-102-persist-dominant-colour'),
				},
				options: { fetchPolicy: 'store-or-network' },
			};
		},
		isCritical: true,
	}),
);
